import {ServiceCopilot, useAuthentificationStore} from '#imports';

export default defineNuxtRouteMiddleware((to) => {
  const authentificationStore = useAuthentificationStore();
  const vehiculeStore = useVehiculeStore();

  // 1. On vérifie si la route demandée commence par /recherche-prestataire
  // Cela permet d'autoriser /recherche-prestataire/recherche, /recherche-prestataire/detail, etc.
  const isPublicRoute =
    to.path === '/login' ||
    to.path === '/create-account' ||
    to.path === '/demande-reset-password' ||
    to.path === '/reset-password' ||
    to.path.startsWith('/recherche-fournisseurs'); // <--- L'AJOUT EST ICI

  if (!authentificationStore.isAuthenticated() && !isPublicRoute) {
    return navigateTo('/login');
  }

  // --- GESTION DES PERMISSIONS (Utilisateurs connectés) ---

  const routePermissions = {
    'documents/transmettre-document': ServiceCopilot.TRANSMETTRE_DOCUMENT,
    documents: ServiceCopilot.DOCUMENTS_VEHICULE,
    'releve-kilometrique': ServiceCopilot.RELEVE_KILOMETRIQUE,
    // On laisse cette ligne commentée pour ne pas exiger de permission spécifique
    // 'recherche-prestataire/recherche': ServiceCopilot.TROUVER_PRESTATAIRE,
    // 'etat-des-lieux': ServiceCopilot.ETAT_DES_LIEUX_VEHICULE,
    'reparation-carrosserie': ServiceCopilot.REPARATION_CARROSSERIE,
  };

  // Récupère la permission requise
  // Note: to.path.replace(/^\//, '') retire le slash initial pour matcher les clés de l'objet
  const requiredPermission = routePermissions[to.path.replace(/^\//, '')];

  // Si aucune permission n'est mappée (undefined), on laisse passer
  // C'est ce qui se passera pour 'recherche-prestataire/recherche' car la ligne est commentée plus haut
  if (requiredPermission === undefined && requiredPermission !== 0) {
    return;
  }

  // Si on arrive ici, c'est qu'une permission est requise.
  // Il faut s'assurer que l'utilisateur a bien chargé ses infos (cas edge : reload page)
  const userPermissions = vehiculeStore.getServices();

  if (!userPermissions.includes(requiredPermission)) {
    return navigateTo('/401');
  }
});
